import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import axios from 'axios';
import {useIntl} from 'react-intl';
import {BillSearchResponse} from '../../../interfaces/bill';
import {downloadFile} from '../../documents/api';
import {useState} from 'react';
import Loading from '../../../common/components/Loading';

interface DownloadBillProps {
    bill: BillSearchResponse;
}

const DownloadBill = ({bill}: DownloadBillProps): JSX.Element => {
    const intl = useIntl();
    const [isLoading, setIsLoading] = useState(false);

    if (isLoading) {
        return <Loading className="d-inline" />;
    }

    return (
        <span
            className="cursor-pointer"
            onClick={() => {
                setIsLoading(true);
                downloadFile(`${axios.defaults.baseURL}/api/billing/bills/${bill.id}/pdf`).finally(
                    () => setIsLoading(false)
                );
            }}
        >
            <OverlayTrigger
                overlay={
                    <Tooltip>
                        <span>{intl.formatMessage({id: 'ADMINISTRATIVE.BILL.DOWNLOAD'})}</span>
                    </Tooltip>
                }
                placement={'top'}
            >
                <i className="fs-1 fa-solid fa-download"></i>
            </OverlayTrigger>
        </span>
    );
};

export default DownloadBill;
